import type { FacetViewProps } from "@elastic/react-search-ui-views";
import { Checkbox, FilterWrapper } from "components/common/elastic/style";
import { useEffect, useState } from "react";
import { appendClassName } from "utils";

const BooleanFacet = ({
  className,
  label,
  options,
  onRemove,
  onSelect,
  values
}: FacetViewProps) => {
  const trueOptions = options.find((option) => option.value === "true");
  const isSelected = values.includes("true");

  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  const handleToggle = () => {
    if (isSelected) {
      onRemove("true");
    } else {
      onSelect("true");
    }
  };

  useEffect(() => {
    if (trueOptions) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [trueOptions, isDisabled]);

  return (
    <FilterWrapper className={appendClassName(className)}>
      <Checkbox
        type="checkbox"
        label={label}
        id={`facet-${label}`}
        name={`facet-${label}`}
        disabled={isDisabled}
        checked={isSelected}
        onChange={handleToggle}
        style={{ fontWeight: isSelected ? "bold" : "normal" }}
      />
    </FilterWrapper>
  );
};

export default BooleanFacet;
